
import { AuthService } from '@/services/auth.service'
export async function checkAccessMiddleware (to, from, next) {
  next()
}

export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)
  if (pageTitle) window.document.title = pageTitle.meta.title
  next()
}

export function authGuard (to, from, next) {
  const tokenId = AuthService.getCookie('TID')
  const idUserData = AuthService.getLocalStorage('idUserData')
  if (tokenId !== '' && idUserData !== '' && tokenId !== null && idUserData !== null) {
    next('/dashboard')
  }
  next()
}
